import { Stack } from "@mui/material";
import {
  AreaColorMap,
  AreaHotkeyMap,
  AreaMaterialsMap,
} from "./scrapEyeLayoutCommon";
import { formatArea } from "components/identifyEventsTool/utils/formatArea";
import { EcsItem } from "./EcsItem";
import { CabItem } from "./CabItem";
import { BayItem } from "./BayItem";
import { BaySpacer } from "./BaySpacer";

/**
 * Renders a column of layout items (bay style).
 * Each column renders vertically.
 */
export const BayColumn = ({
  items,
  onSelectArea,
  nonSelectableAreas,
  areaHotkeys,
  areaColors,
  areaMaterials,
  cabLabel,
  selectedArea,
}: {
  items: readonly (string | null)[];
  onSelectArea?: (area: string) => void;
  nonSelectableAreas: readonly string[];
  areaHotkeys?: AreaHotkeyMap;
  areaColors?: AreaColorMap;
  areaMaterials?: AreaMaterialsMap;
  cabLabel: string;
  selectedArea?: string | null;
}) => {
  return (
    <Stack spacing={1} alignItems="center">
      {items.map((name, index) => {
        if (name === null) {
          return <BaySpacer key={index.toString() + "spacer"} />;
        }

        const isSelectable = !nonSelectableAreas.includes(name);
        const hotkey = areaHotkeys?.[name.toLowerCase()] ?? areaHotkeys?.[name];
        const material =
          areaMaterials?.[name.toLowerCase()] ?? areaMaterials?.[name];
        const overrideColor =
          areaColors?.[name.toLowerCase()] ?? areaColors?.[name];

        if (name === "ECS") {
          return (
            <EcsItem
              key={index.toString() + "ECS"}
              hotkey={hotkey}
              onClick={onSelectArea}
              isSelectable={!!hotkey}
            />
          );
        }

        if (name === "Cab") {
          return <CabItem key={index.toString() + "Cab"} label={cabLabel} />;
        }

        return (
          <BayItem
            key={index.toString() + name}
            areaId={name}
            displayName={formatArea(name)}
            onClick={onSelectArea}
            isSelectable={isSelectable}
            hotkey={hotkey}
            material={material}
            overrideColor={overrideColor}
            isSelected={selectedArea === name}
            isDimmed={selectedArea != null && selectedArea !== name}
          />
        );
      })}
    </Stack>
  );
};
